/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
// import config from "../config/approveCredential.config.json";
import notification from "../config/notifications.config.json";
import axios from "axios";

import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { APPROVE_CREDENTIAL } from "../graphql";
import { VApplication } from "../../../application";

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IApproveCredentialMethods extends IPluginMethodMap {
  getApproveCredential(args: any): Promise<any>;
}

export interface ApproveCredentialProps {
  id: string;
}

export class ApproveCredentialService implements IAgentPlugin {
  readonly methods: IApproveCredentialMethods;

  constructor() {
    this.methods = {
      getApproveCredential: this.getApproveCredential.bind(this),
    };
  }

  async getApproveCredential(args: ApproveCredentialProps) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    try {
      if (client) {
        console.log('args',args)
        const res = await client.mutate({
          mutation: APPROVE_CREDENTIAL,
          variables: {
            "input": {
              ...args
            }
          },
          fetchPolicy: "no-cache",
        });
        console.log(res)
        if (res?.data?.approveCredential?.credential) {
          return {
            notification: notification?.revokeCredential,
          };
        }
      }
    } catch (err: any) {
      // console.log("error in approve credential", err?.message);
      throw err;
    }
  }
}
